export default __webpack_public_path__ + "static/media/bb3.49af96dd.png";